import { useSuspenseQuery } from "@apollo/client/react";
import type { CompoundRecordVersionsOrderBy, OrderBy } from "~/common/types/graphql";
import {
  GetCompoundRecordVersionsDocument,
  type GetCompoundRecordVersionsQuery,
  type GetCompoundRecordVersionsQueryVariables,
} from "~/features/compoundEntities/gqls";
import type { CompoundVersionOption } from "~/features/compoundEntities/types";

const ORDER_BY: CompoundRecordVersionsOrderBy[] = [{ createdAt: "DESC" as OrderBy }];

/** All compound-record versions, newest-first — drives the list header version selector. */
export function useCompoundEntityVersions(): { versions: CompoundVersionOption[] } {
  const { data } = useSuspenseQuery<GetCompoundRecordVersionsQuery, GetCompoundRecordVersionsQueryVariables>(
    GetCompoundRecordVersionsDocument,
    { variables: { limit: 1000, offset: 0, orderBy: ORDER_BY } },
  );
  const versions = (data.compoundRecordVersions ?? []).map((v) => ({ id: v.id, version: v.version }));
  return { versions };
}
